import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsCampaignAlertPreferencesUpdateCacheKeys: AllRouteEndpoints[] = [];
